import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getIndexMetricData, getSortedMetrics, getSvgrMap } from "../../utils/dashboardUtils";
import MetricCard from "../MetricCard";
import IndexBanner from "../IndexBanner";
import CrimeCategoryChart from "../charts/CrimeCategoryChart";

const LivabilityMetrics = ({ indicators, metadata, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {  
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    console.log("Livability data:", sortedMetrics);

    let metricsForTab = indicators; // Get metrics for the current tab

    // Find the current tab index metric data and id
    const { indexMetricId, indexMetricData } = getIndexMetricData(tab, metadata, indicators);

    // Exclude the index metric from the list of metrics
    if (indexMetricId) {
        metricsForTab = metricsForTab.filter((metric) => metric.id !== indexMetricId);
    }

    if (!metricsForTab || metricsForTab.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    // Define metrics for order
    const l: DisaggregatedMetric[] = sortedMetrics[0];
    const crimeIndex = indicators.find(i => i.id === 56);
    const personal = indicators.find(i => i.id == 58);
    const property = indicators.find(i => i.id == 59);
    const society = indicators.find(i => i.id == 60);

    return (
        <>
            <div className="mb-2">
                <IndexBanner
                    key={indexMetricId}
                    metric={indexMetricData}
                    svg={undefined}
                    disaggData={indicators}
                    geoDetails={geoDetails}
                    geoTag={geoTag}
                    selectionActive={selectionActive}
                />
            </div>

            <p className="text-[10px] text-port-text mx-4">
            Activate the <span aria-hidden="true">🛈</span> <strong>button</strong> to expand additional information about a metric.
            </p>
            <p className="text-port-text mx-4 text-[10px]">Data updates published March 30, 2026.</p>

            <div className="mx-auto px-4 pb-8 pt-4">
                <div className="grid grid-cols-2 gap-4">
                    {l.map(metric => (
                        <MetricCard
                            key={metric.id}
                            metric={metric}
                            width="w-full"
                            svg={getSvgrMap(metric.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                        />
                    ))}

                    <div className="col-span-2 w-full">
                        <CrimeCategoryChart
                            crimeIndexMetric={crimeIndex}
                            propertyMetric={property}
                            personalMetric={personal}
                            societyMetric={society}
                            subtitle="Total from January 1, 2025 to December 31, 2025"
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive
                            disaggData={indicators}
                            height="h-28"
                        />
                    </div>
                    

                    {/* <div className="col-span-2 w-full">
                        <div 
                            className="relative overflow-hidden group hover:shadow-md transition-all border rounded-xl bg-white"
                            style={{ 
                                borderLeftWidth: "4px", borderLeftColor: color,
                            }}
                        >
                            <div className="bg-white p-4">
                                {categorizedData.Livability.filter(metric => 
                                    [getMetricGroupChartId(tab, "crimerisk")].includes(metric.id)
                                ).map(metric => (
                                    <DisaggregateMetricCard
                                        key={metric.id}
                                        id={metric.id}
                                        title={metric.name}
                                        svg={getSvgMap(metric.id)}
                                        disaggData={indicators}
                                        geoDetails={geoDetails}
                                        geoTag={geoTag}
                                        selectionActive={selectionActive}
                                    />
                                ))}
                                <div className="relative w-full">
                                    <div className="absolute top-0 bottom-0 w-[2px]" style={{ left: '280px', backgroundColor: 'rgba(239, 68, 68, 0.4)' }}></div>

                                {personalCrime && 
                                <SingleBar
                                    key={personalCrime.id}
                                    metric={personalCrime}
                                    name='Personal'
                                    width="w-full"
                                    svg={getSvgMap(personalCrime.id)}
                                    disaggData={indicators}
                                    geoDetails={geoDetails}
                                    geoTag={geoTag}
                                    selectionActive={selectionActive}
                                />
                                }

                                {propertyCrime && 
                                <>
                                <SingleBar
                                    key={propertyCrime.id}
                                    metric={propertyCrime}
                                    name="Property"
                                    width="w-full"
                                    svg={getSvgMap(propertyCrime.id)}
                                    disaggData={indicators}
                                    geoDetails={geoDetails}
                                    geoTag={geoTag}
                                    selectionActive={selectionActive}
                                />
                                
                                </>
                                }
                                <p className="text-color-cai-gray text-[9px] absolute -bottom-4" style={{ left: '245px' }}>National Average</p>
                                </div>
                                
                                <p className="text-[#4D4D4D] text-[11px] ml-2 my-4">{categorizedData.Livability.filter(metric => 
                                    [getMetricGroupChartId(tab, "crimerisk")].includes(metric.id) // Crime Risk
                                ).map(metric => metric.versions[0].unit_descriptor)}</p>
                            </div>
                            <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-[#2258e5]/50 to-[#00ac4e]/50 opacity-0 group-hover:opacity-100 transition-opacity" />
                        </div>
                    </div> */}
                </div>
            </div>
        </>
    );
}

export default LivabilityMetrics;